import { environment } from "../config/environment";

// Constants
const API_BASE_URL = environment.apiBaseUrl;

// Parse JWT token for role checking
export function parseJwt(token: string): any {
  try {
    // Ensure token is a string
    if (typeof token !== "string") {
      console.error("Token is not a string:", typeof token, token);
      return null;
    }

    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error parsing JWT:", error);
    return null;
  }
}

// Check if user has a specific role
export function checkIfUserIsRole(token: string, role: string): boolean {
  try {
    const tokenPayload = parseJwt(token);
    if (!tokenPayload) return false;

    const scopes = (tokenPayload.scope || "").split(" ");
    const isRole = scopes.includes("role:" + role);

    return isRole;
  } catch (error) {
    console.error("Error checking role:", error);
    return false;
  }
}

export { API_BASE_URL };
